import type { CreditActionFormProps } from './types';

const inputClass =
  'bg-[#0d1117] border border-[#30363d] text-[#c9d1d9] px-2.5 py-2 rounded-md text-sm font-mono w-full focus:outline-none focus:border-[#58a6ff]';

const buttonBase =
  'px-4 py-2 rounded-md text-sm font-semibold cursor-pointer border transition-colors disabled:opacity-50 disabled:cursor-not-allowed';

export const CreditActionForm = ({
  amount,
  resetTotal,
  description,
  loading,
  onAmountChange,
  onResetTotalChange,
  onDescriptionChange,
  onAddCredits,
  onDeductCredits,
  onResetCredits,
}: CreditActionFormProps) => {
  const parsedAmount = parseInt(amount, 10);
  const isAmountValid = !isNaN(parsedAmount) && parsedAmount >= 1;

  const parsedResetTotal = parseInt(resetTotal, 10);
  const isResetTotalValid = !isNaN(parsedResetTotal) && parsedResetTotal >= 0;

  return (
    <div className="bg-[#161b22] border border-[#30363d] rounded-lg p-4 mb-4">
      <h2 className="text-sm text-[#8b949e] uppercase tracking-wide mb-3">
        Manage Organization Credits
      </h2>

      <div className="flex gap-3 mb-3 flex-wrap">
        <div className="flex-1 min-w-[120px] max-w-[200px]">
          <label className="block text-[12px] text-[#8b949e] mb-1">
            Amount
          </label>
          <input
            type="number"
            min="1"
            className={inputClass}
            value={amount}
            onChange={(event) => onAmountChange(event.target.value)}
            placeholder="e.g. 10"
          />
        </div>
        <div className="flex-1 min-w-[200px]">
          <label className="block text-[12px] text-[#8b949e] mb-1">
            Description (optional)
          </label>
          <input
            type="text"
            className={inputClass}
            value={description}
            onChange={(event) => onDescriptionChange(event.target.value)}
            placeholder="Reason for credit change..."
          />
        </div>
      </div>

      <div className="flex gap-3">
        <button
          className={`${buttonBase} bg-[#238636] border-[#238636] text-white hover:bg-[#2ea043]`}
          disabled={!isAmountValid || loading}
          onClick={onAddCredits}
        >
          Add Credits
        </button>
        <button
          className={`${buttonBase} bg-[#da3633] border-[#da3633] text-white hover:bg-[#f85149]`}
          disabled={!isAmountValid || loading}
          onClick={onDeductCredits}
        >
          Deduct Credits
        </button>
      </div>
      <div className="border-t border-[#30363d] mt-4 pt-4 flex gap-3 flex-wrap items-end">
        <div className="flex-1 min-w-[120px] max-w-[200px]">
          <label className="block text-[12px] text-[#8b949e] mb-1">
            Reset total to
          </label>
          <input
            type="number"
            min="0"
            className={inputClass}
            value={resetTotal}
            onChange={(event) => onResetTotalChange(event.target.value)}
            placeholder="e.g. 300"
          />
        </div>
        <button
          className={`${buttonBase} bg-[#9e6a03] border-[#9e6a03] text-white hover:bg-[#bb8009]`}
          disabled={!isResetTotalValid || loading}
          onClick={onResetCredits}
        >
          Reset Total
        </button>
        <p className="basis-full text-[12px] text-[#8b949e]">
          Sets total to this value; the removed credits count as used first.
        </p>
      </div>
    </div>
  );
};
